/* Sticky bar plan picker (2026-10-16, Oliver: "like IM8, a month instead of a day").
   The bar is a remote for the size cards above it: it reads the plans from the cards and picking
   one clicks that card's radio, so the price, Autoship, plan details and the Free Starter Kit
   property all follow the existing code. Nothing about the plan is stored here. */
(function () {
  "use strict";
  if (window.__fcspInit) return;
  window.__fcspInit = true;

  function money(c) { return (window.FL && FL.money) ? FL.money(c) : (c / 100).toFixed(2); }
  function esc(x) { return String(x).replace(/[&<>"]/g, function (ch) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]; }); }
  function cents(el) { var n = el ? parseInt(el.getAttribute("data-fl-cents"), 10) : NaN; return isFinite(n) ? n : NaN; }
  function text(el) { return el && !el.hidden ? el.textContent.replace(/\s+/g, " ").trim() : ""; }

  /* the same rounding as the green −X% badges (Theme settings → Single product) */
  function pct(price, was, step, dir) {
    if (!(was > price)) return 0;
    var p = (was - price) * 100 / was / step;
    return Math.round(dir === "nearest" ? p : p - 0.499) * step;
  }

  /* {supply} {size} {pct} {save} {month} {total} {was}; money values in bold where asked */
  function fill(tpl, d, bold) {
    var e = esc(tpl);
    function b(v) { return bold ? "<strong>" + esc(v) + "</strong>" : esc(v); }
    /* the months read strong and the size lighter, as on the size cards */
    return e.replace(/\{supply\}/g, '<span class="fcsp__sup">' + esc(d.supply) + "</span>").replace(/\{size\}/g, '<span class="fcsp__sz">' + esc(d.size) + "</span>")
      .replace(/\{pct\}/g, String(d.pct)).replace(/\{save\}/g, esc(d.save))
      .replace(/\{month\}/g, b(d.month)).replace(/\{total\}/g, b(d.total)).replace(/\{was\}/g, esc(d.was))
      .replace(/\s*·\s*(<span class="fcsp__sz"><\/span>)/, "$1").replace(/(<span class="fcsp__sup"><\/span>)\s*·\s*/, "$1");
  }

  function init(root) {
    if (root.__fcsp) return;
    root.__fcsp = true;
    var bar = root.closest("[data-fl-sticky-atc]");
    var scope = root.closest('[class*="fl-x-"]') || document;
    var btn = root.querySelector("[data-fcsp-btn]"), list = root.querySelector("[data-fcsp-list]");
    var nameEl = root.querySelector("[data-fcsp-name]"), saveEl = root.querySelector("[data-fcsp-save]"), priceEl = root.querySelector("[data-fcsp-price]");
    var tName = root.getAttribute("data-name"), tSave = root.getAttribute("data-save"), tPrice = root.getAttribute("data-price");
    var step = parseFloat(root.getAttribute("data-step")) || 1, dir = root.getAttribute("data-dir") || "down";
    var flags = root.getAttribute("data-flags") === "1";
    var uid = list.id || "Fcsp";

    function cards() {
      /* the first card deck in this section (the size picker); [data-fl-card] order = what the page shows */
      var deck = scope.querySelector("[data-fl-cards]") || scope;
      return Array.prototype.slice.call(deck.querySelectorAll("[data-fl-card]")).filter(function (c) { return c.querySelector("input[type=radio]"); });
    }
    function read(card) {
      var input = card.querySelector("input[type=radio]");
      var wasEl = card.querySelector("[data-fl-card-was]");
      var price = cents(card.querySelector("[data-fl-card-price]"));
      var was = wasEl && !wasEl.hidden ? cents(wasEl) : NaN;
      var mo = cents(card.querySelector("[data-fl-card-permo-amt]"));
      if (!isFinite(mo)) mo = price;
      var p = isFinite(price) && isFinite(was) ? pct(price, was, step, dir) : 0;
      var outEl = card.querySelector("[data-fl-card-out]");
      return {
        card: card, input: input, checked: input.checked,
        out: card.classList.contains("is-out") || !!(outEl && !outEl.hidden),
        supply: text(card.querySelector("[data-fl-card-supply]")),
        size: text(card.querySelector(".fl-vcard__size")) || card.getAttribute("data-value") || "",
        flag: text(card.querySelector("[data-fl-card-flag]")),
        pct: p,
        save: p > 0 ? money(was - price) : "",
        month: isFinite(mo) ? money(mo) : "",
        total: isFinite(price) ? money(price) : "",
        was: p > 0 ? money(was) : ""
      };
    }

    function render() {
      var all = cards();
      if (!all.length) return;
      var data = all.map(read);
      var cur = data.filter(function (d) { return d.checked; })[0] || data[0];
      nameEl.innerHTML = fill(tName, cur, false);
      var sv = tSave && cur.pct > 0 ? fill(tSave, cur, false) : "";
      saveEl.innerHTML = sv;
      saveEl.hidden = !sv;
      priceEl.innerHTML = fill(tPrice, cur, true);
      btn.setAttribute("aria-label", nameEl.textContent + (sv ? " " + saveEl.textContent : "") + ", " + priceEl.textContent);
      list.innerHTML = data.map(function (d, i) {
        var save = tSave && d.pct > 0 ? '<span class="fcsp__save">' + fill(tSave, d, false) + "</span>" : "";
        var flag = flags && d.flag ? '<span class="fcsp__flag">' + esc(d.flag) + "</span>" : "";
        return '<div class="fcsp__opt' + (d.checked ? " is-on" : "") + (d.out ? " is-out" : "") + '" role="option" id="' + uid + "-" + i + '" data-i="' + i + '" aria-selected="' + d.checked + '"' + (d.out ? ' aria-disabled="true"' : "") + ">" +
          '<span class="fcsp__dot" aria-hidden="true"></span>' +
          '<span class="fcsp__o-main"><span class="fcsp__o-name">' + fill(tName, d, false) + "</span>" +
          (save || flag ? '<span class="fcsp__o-sub">' + save + flag + "</span>" : "") + "</span>" +
          '<span class="fcsp__o-price">' + fill(tPrice, d, true) + "</span></div>";
      }).join("");
      /* a spoken name per plan: "3 months · 150 ml, Save 50%, Best value, €46,66 / month" */
      Array.prototype.forEach.call(list.querySelectorAll(".fcsp__opt"), function (o) {
        var parts = [".fcsp__o-name", ".fcsp__save", ".fcsp__flag", ".fcsp__o-price"].map(function (q) { var e = o.querySelector(q); return e ? e.textContent.replace(/\s+/g, " ").trim() : ""; });
        o.setAttribute("aria-label", parts.filter(Boolean).join(", "));
      });
      if (!list.hidden && active >= 0) focusOpt(active);
    }

    /* 2026-10-16 (Oliver): a plan picked in the bar takes the page up to that plan's card and price —
       its top just under the sticky header, which slides back in while the page goes up (as fc-plan-kit.js) */
    var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function headerFull() {
      var full = 0;
      document.querySelectorAll(".fl-header, header, [id$='__header']").forEach(function (h) {
        var cs = getComputedStyle(h), r = h.getBoundingClientRect();
        if ((cs.position === "sticky" || cs.position === "fixed") && r.height < innerHeight / 3) full = Math.max(full, r.height);
      });
      return full;
    }
    function goTo(card) {
      function target() { return Math.max(0, Math.round(window.scrollY + card.getBoundingClientRect().top - headerFull() - 12)); }
      window.scrollTo({ top: target(), behavior: still ? "auto" : "smooth" });
      /* the card that was open above it folds while the page moves: land exactly once it has */
      setTimeout(function () {
        var t = target();
        if (Math.abs(t - window.scrollY) > 3) window.scrollTo({ top: t, behavior: still ? "auto" : "smooth" });
      }, still ? 0 : 560);
    }

    var active = -1;
    function opts() { return Array.prototype.slice.call(list.querySelectorAll(".fcsp__opt")); }
    function focusOpt(i) {
      var o = opts();
      if (!o.length) return;
      active = (i + o.length) % o.length;
      o.forEach(function (x, k) { x.classList.toggle("is-focus", k === active); });
      list.setAttribute("aria-activedescendant", o[active].id);
    }
    function open() {
      render();
      list.hidden = false;
      root.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
      var o = opts(), on = o.findIndex ? o.findIndex(function (x) { return x.classList.contains("is-on"); }) : 0;
      focusOpt(on < 0 ? 0 : on);
      list.setAttribute("tabindex", "-1");
      list.focus({ preventScroll: true });
    }
    function close(back) {
      if (list.hidden) return;
      list.hidden = true;
      root.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
      list.removeAttribute("aria-activedescendant");
      if (back) btn.focus({ preventScroll: true });
    }
    function pick(i) {
      var all = cards(), c = all[i];
      if (!c) return;
      var d = read(c);
      if (d.out) return;
      close(false);
      if (!d.checked) d.input.click();
      goTo(c);
    }

    btn.addEventListener("click", function () { list.hidden ? open() : close(true); });
    list.addEventListener("click", function (e) {
      var o = e.target.closest(".fcsp__opt");
      if (o) pick(parseInt(o.getAttribute("data-i"), 10));
    });
    list.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); focusOpt(active + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); focusOpt(active - 1); }
      else if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(active); }
      else if (e.key === "Escape" || e.key === "Tab") { close(e.key === "Escape"); }
    });
    btn.addEventListener("keydown", function (e) {
      if ((e.key === "ArrowUp" || e.key === "ArrowDown") && list.hidden) { e.preventDefault(); open(); }
    });
    document.addEventListener("pointerdown", function (e) { if (!root.contains(e.target)) close(false); }, true);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(true); });
    document.addEventListener("fl:drawer:open", function () { close(false); });
    /* the bar slides away when the page goes back up to the main button: take the list with it */
    if (bar && window.MutationObserver) new MutationObserver(function () { if (!bar.classList.contains("is-active")) close(false); }).observe(bar, { attributes: true, attributeFilter: ["class"] });

    /* follow the cards: a size click, the Autoship tick, prices animating to the plan price */
    scope.addEventListener("change", function () { setTimeout(render, 0); });
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(render, 30); });
      cards().forEach(function (c) { mo.observe(c, { subtree: true, attributes: true, attributeFilter: ["data-fl-cents", "hidden", "class"] }); });
    }
    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll("[data-fcsp]"), init); }
  if (document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
